var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuCheckmarkOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 11.4302C2 12.4607 2.57215 13 3.66582 13H12.3291C13.4278 13 14 12.4607 14 11.4302V5.56982C14 4.53933 13.4278 4 12.3291 4H3.66582C2.57215 4 2 4.53451 2 5.56982V11.4302ZM3.76709 5.69984C3.5038 5.69984 3.29114 5.48796 3.29114 5.24719C3.29114 5.01124 3.5038 4.79936 3.76709 4.79936C4.02532 4.79936 4.23797 5.01124 4.23797 5.24719C4.23797 5.48796 4.02532 5.69984 3.76709 5.69984ZM5.26076 5.69984C4.99747 5.69984 4.78987 5.48796 4.78987 5.24719C4.78987 5.01124 4.99747 4.79936 5.26076 4.79936C5.51899 4.79936 5.73165 5.01124 5.73165 5.24719C5.73165 5.48796 5.51899 5.69984 5.26076 5.69984ZM6.75443 5.69984C6.4962 5.69984 6.28354 5.48796 6.28354 5.24719C6.28354 5.01124 6.4962 4.79936 6.75443 4.79936C7.01772 4.79936 7.22532 5.01124 7.22532 5.24719C7.22532 5.48796 7.01772 5.69984 6.75443 5.69984ZM3.00759 11.3435V6.4992H12.9873V11.3435C12.9873 11.8106 12.7291 12.0417 12.2633 12.0417H3.73165C3.26582 12.0417 3.00759 11.8106 3.00759 11.3435Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCheckmarkOn);
export default __webpack_public_path__ + "static/media/menu-checkmark-on.1531625b1f6526c59fd808ba713ffd46.svg";
export { ForwardRef as ReactComponent };